import { useQuery } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export interface IGetCustomizedOrdersParams {
    limit: number;
    cursor: string | null;
    direction: string;
}

export const useGetCustomizedOrders = (
    queryKey: string | string[],
    parameters: IGetCustomizedOrdersParams,
) => {
    const auth = useAuth();
    return useQuery(queryKey, async () => {
        if (!auth.token) {
            throw new Error(
                "Cannot fetch customized orders without authorization token.",
            );
        }

        return await api.orders.Order.getCustomizedOrders({
            ...parameters,
            token: auth.token,
        });
    });
};
